import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getRunningVehicle, getSingleRunningVehicle, editRunningVehicle, createRunningVehicle } from '../../services/vm/apiController';
import { factoryId, loggedInUser } from '../../store/reducers/account_reducer';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col, Alert } from 'react-bootstrap';
import { formatDate } from '../../util/helper';
import { toast, ToastContainer } from 'react-toastify';
import { DeleteIcon, EditIcon, ViewIcon } from './components/icons';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import FactoryDropdown from './FactoryDropdown';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';

const RunningVehicleList = () => {
  let user = useSelector(loggedInUser);
  const [poNumber, setPoNumber] = useState('');
  const [status, setStatus] = useState('ON ROAD');
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [runsVehicleList, setRunsVehicleList] = useState([]);
  const [show, setShow] = useState(false);
  const [vehicleModelShow, setVehicleModelShow] = useState(false);
  const formFields = {
    vehicleModelName: '',
    registrationNumber: '',
    chasisNumber: '',
    engineNumber: '',
    charges: '',
    description: '',
    onRoadDate: '',
    location: '',
    userManual: null,
    userManualName: '',
    warranty: false,
    warrantyDate: '',
    driverName: '',
    driverMobile: '',
    driverAddress: '',
    referenceName: '',
    referenceMobile: '',
    status: 'ON ROAD',
    warrantyDocument: null,
    warrantyDocumentName: '',
    bill: null,
    billName: '',
    vehicleImage1: null,
    vehicleImageName1: '',
    vehicleImage2: null,
    vehicleImageName2: '',
    vehicleImage3: null,
    vehicleImageName3: '',
  };
  const [purchaseOrderForm, setPurchaseOrderForm] = useState(formFields);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleVehicleClose = () => {
    setVehicleModelShow(false);
  };

  const handleVehicleModelShow = () => {
    setVehicleModelShow(true);
    setPurchaseOrderForm(formFields);
  };

  const handleShow = (event, id) => {
    event.preventDefault();
    const getRunningVehi = async () => {
      const runningVehicleVal = await getSingleRunningVehicle(id);
      const hole = runningVehicleVal?.data;
      if (hole.onRoadDate !== null) hole.onRoadDate = moment(hole.onRoadDate).format('YYYY-MM-DD');
      if (hole.warrantyDate !== null) hole.warrantyDate = moment(hole.warrantyDate).format('YYYY-MM-DD');
      hole.userManual = null;
      hole.warrantyDocument = null;
      hole.bill = null;
      hole.vehicleImage1 = null;
      hole.vehicleImage2 = null;
      hole.vehicleImage3 = null;
      delete hole.PurchaseOrder;
      delete hole.VehicleRequest;
      setPurchaseOrderForm(hole);
    };
    getRunningVehi();
    setShow(true);
  };

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPurchaseOrderForm({ ...purchaseOrderForm, [name]: value });
  };

  const onChangeManual = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, userManual: file || null, userManualName: file?.name || '' });
    }
  };

  const onChangeWarrantyDocument = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, warrantyDocument: file || null, warrantyDocumentName: file?.name || '' });
    }
  };
  const onChangeBill = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, bill: file || null, billName: file?.name || '' });
    }
  };
  const onChangeVehicleImage1 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, vehicleImage1: file || null, vehicleImageName1: file?.name || '' });
    }
  };
  const onChangeVehicleImage2 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, vehicleImage2: file || null, vehicleImageName2: file?.name || '' });
    }
  };
  const onChangeVehicleImage3 = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, vehicleImage3: file || null, vehicleImageName3: file?.name || '' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    for (var key in purchaseOrderForm) {
      if (
        key === 'userManual' ||
        key === 'userManualName' ||
        key === 'warrantyDocument' ||
        key === 'warrantyDocumentName' ||
        key === 'bill' ||
        key === 'billName' ||
        key === 'vehicleImage1' ||
        key === 'vehicleImageName1' ||
        key === 'vehicleImage2' ||
        key === 'vehicleImageName2' ||
        key === 'vehicleImage3' ||
        key === 'vehicleImageName3'
      )
        continue;
      formData.append(key, purchaseOrderForm[key]);
    }
    if (purchaseOrderForm.userManual !== null)
      formData.append('userManual', purchaseOrderForm['userManual'], purchaseOrderForm.userManualName);
    if (purchaseOrderForm.warrantyDocument !== null)
      formData.append('warrantyDocument', purchaseOrderForm['warrantyDocument'], purchaseOrderForm.warrantyDocumentName);
    if (purchaseOrderForm.bill !== null) formData.append('bill', purchaseOrderForm['bill'], purchaseOrderForm.billName);
    if (purchaseOrderForm.vehicleImage1 !== null)
      formData.append('vehicleImage1', purchaseOrderForm['vehicleImage1'], purchaseOrderForm.vehicleImageName1);
    if (purchaseOrderForm.vehicleImage2 !== null)
      formData.append('vehicleImage2', purchaseOrderForm['vehicleImage2'], purchaseOrderForm.vehicleImageName2);
    if (purchaseOrderForm.vehicleImage3 !== null)
      formData.append('vehicleImage3', purchaseOrderForm['vehicleImage3'], purchaseOrderForm.vehicleImageName3);

    if (formData.get('id') && formData.get('id') !== null) {
      try {
        setIsButtonDisabled(false);
        await editRunningVehicle(formData, formData.get('id'));
        setShow(false);
        getRunVehicle();
        toast.success('Running Vehicle updated successfully');
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || err?.message || 'Something went wrong', { autoClose: 3000 });
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        await createRunningVehicle(formData);
        toast.success('Running Vehicle added successfully');
        setVehicleModelShow(false);
        getRunVehicle();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || err?.message || 'Something went wrong', { autoClose: 3000 });
      } finally {
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  const getRunningVehicleList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0, id = 0) => {
    try {
      let condition = {
        name: poNumber || '',
        status: status || '',
      };
      if (user && user.factoryId) {
        condition['factoryId'] = user.factoryId;
      }
      const runningVehicle = await getRunningVehicle(offset, limit, condition, id);
      return id === 0
        ? {
          data: (runningVehicle && runningVehicle.data.rows) || [],
          totalRecords: (runningVehicle && runningVehicle.data && runningVehicle.data.count) || 0,
        }
        : {
          data: (runningVehicle && runningVehicle.data) || [],
        };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getRunVehicle();
      }
    },
    [poNumber, status],
    DEBOUNCE_DELAY
  );

  async function getRunVehicle() {
    const data = await getRunningVehicleList(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(data.totalRecords);
    setRunsVehicleList(data?.data);
  }

  useEffect(() => {
    getRunVehicle();
  }, [currentPage]);

  const handleToggle = (e) => {
    const { checked } = e.target;
    setPurchaseOrderForm({ ...purchaseOrderForm, warranty: checked });
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="">Running Vehicle List</a>
          </li>
        </ol>
      </nav>
      <div className="card top-card">
        <div className="card-body">
          <div className="row">
            <FactoryDropdown onFactoryChange={getRunVehicle} />
            <div className="form-group col-md-2 col-lg-2">
              <label htmlFor="exampleInputEmail1">PO Number</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputEmail1"
                placeholder="Please enter PO Number"
                value={poNumber}
                onChange={(e) => setPoNumber(e.target.value)}
              />
            </div>
            <div className="form-group col-md-2 col-lg-2">
              <label htmlFor="exampleInputEmail1">Status</label>
              <Form.Select value={status} onChange={(e) => setStatus(e.target.value)} className="all-select-custom" aria-label="Default select example">
                <option value="">All Vehicles</option>
                <option value="ON ROAD">ON ROAD</option>
                <option value="SCRAP-RESELL">SCRAP-RESELL</option>
              </Form.Select>
            </div>
            <div className="form-group col-md-2 col-lg-2">
              <div className="btn-wrapper justify-content-start cmt-3">
                {/* <button type="button" className="btn app-btn-primary" onClick={getRunVehicle}>Search</button> */}
                <button type="button" className="btn app-btn-default" onClick={(e) => setPoNumber('')}>
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Running Vehicle | {totalRecords ?? 0}
          </h4>
          <button type="button" className="btn app-btn-default dark-color" onClick={handleVehicleModelShow}>
            Create
          </button>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Registration Number</th>
                    <th>Vehicle Model Name</th>
                    <th>Description</th>
                    <th>On Road Date</th>
                    <th>Location</th>
                    <th>Status</th>
                    <th>Created Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {runsVehicleList?.map((request, index) => {
                    return (
                      <tr key={request.id} className={request.status === 'SCRAP-RESELL' ? 'resell-scrap' : ''}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{request.registrationNumber}</td>
                        <td>{!request.VehicleRequestId ? request.vehicleModelName : request?.VehicleRequest?.model}</td>
                        {/* <td>{request.charges}</td> */}
                        <td>{request.description}</td>
                        <td>{formatDate(request.onRoadDate)}</td>
                        <td>{request.location}</td>
                        <td>{request.status}</td>
                        <td>{formatDate(request.createdAt)}</td>
                        <td className="actions">
                          {request.isDeleted === true ? (
                            ''
                          ) : (
                            <Link to={`/vm/running-vehicle/${request.id}`}>
                              <ViewIcon />
                            </Link>
                          )}
                          &nbsp;&nbsp;
                          {request.isDeleted === true ? (
                            ''
                          ) : (
                            <span onClick={(e) => handleShow(e, request.id)} className="edit-icon">
                              <EditIcon />
                            </span>
                          )}
                          {'  '}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={show} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Edit Running Vehicle</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Vehicle Model Name" className="mb-3">
                  <Form.Control
                    value={purchaseOrderForm.vehicleModelName}
                    className="input"
                    name="vehicleModelName"
                    type="text"
                    placeholder="Vehicle Model Name"
                    required
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Registration Number" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.registrationNumber}
                    className="input"
                    name="registrationNumber"
                    type="text"
                    placeholder="Enter Registration Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Chasis Number" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.chasisNumber}
                    className="input"
                    name="chasisNumber"
                    type="text"
                    placeholder="Enter Chasis Number"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Engine Number" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.engineNumber}
                    className="input"
                    name="engineNumber"
                    type="text"
                    placeholder="Enter Engine Number"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Additional Charges" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.charges}
                    className="input"
                    name="charges"
                    type="text"
                    placeholder="Enter Charges"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="Description"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="On Road Date" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.onRoadDate}
                    className="input"
                    name="onRoadDate"
                    type="date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Location" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.location}
                    className="input"
                    name="location"
                    type="text"
                    placeholder="Location"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">User Manual</Form.Label>
                  <Form.Control onChange={onChangeManual} type="file" name="userManual" aria-required="false" />
                  <p>{purchaseOrderForm.userManualName}</p>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Warranty</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={5} className="warranty-btn mt-3">
                <span>Is Warranty Available?</span>
                <input
                  className="react-switch-checkbox"
                  id={`react-switch-new`}
                  type="checkbox"
                  onChange={handleToggle}
                  checked={purchaseOrderForm.warranty}
                  name="warranty"
                />
                <label className="react-switch-label" htmlFor={`react-switch-new`}>
                  <span className="no">NO</span>
                  <span className={`react-switch-button`} />
                  <span className="yes">YES</span>
                </label>
              </Col>
              {purchaseOrderForm.warranty === true ? (
                <Col xs={4} className="mt-4">
                  <FloatingLabel controlId="floatingInput" label="Warranty Covered Till" className="mt-1">
                    <Form.Control
                      onChange={handleChange}
                      value={purchaseOrderForm.warrantyDate}
                      className="input"
                      name="warrantyDate"
                      type="date"
                    />
                  </FloatingLabel>
                </Col>
              ) : (
                ''
              )}
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Drivers details</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Driver Name">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.driverName}
                    className="input"
                    name="driverName"
                    type="text"
                    placeholder="Driver Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Driver Mobile">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.driverMobile}
                    className="input"
                    name="driverMobile"
                    type="text"
                    placeholder="Driver Mobile"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Driver Address">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.driverAddress}
                    className="input"
                    name="driverAddress"
                    type="text"
                    placeholder="Driver Address"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Reference</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Reference Name" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.referenceName}
                    className="input"
                    name="referenceName"
                    type="text"
                    placeholder="Reference Name"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Reference Mobile" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.referenceMobile}
                    className="input"
                    name="referenceMobile"
                    type="text"
                    placeholder="Reference Mobile"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Documents</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 1</Form.Label>
                  <Form.Control onChange={onChangeWarrantyDocument} type="file" name="warrantyDocument" aria-required="false" />
                  <p>{purchaseOrderForm.warrantyDocumentName}</p>
                </Form.Group>
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 2</Form.Label>
                  <Form.Control onChange={onChangeBill} type="file" name="bill" aria-required="false" />
                  <p>{purchaseOrderForm.billName}</p>
                </Form.Group>
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 3</Form.Label>
                  <Form.Control onChange={onChangeVehicleImage1} type="file" name="vehicleImage1" aria-required="false" />
                  <p>{purchaseOrderForm.vehicleImageName1}</p>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 4</Form.Label>
                  <Form.Control onChange={onChangeVehicleImage2} type="file" name="vehicleImage2" aria-required="false" />
                  <p>{purchaseOrderForm.vehicleImageName2}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 5</Form.Label>
                  <Form.Control onChange={onChangeVehicleImage3} type="file" name="vehicleImage3" aria-required="false" />
                  <p>{purchaseOrderForm.vehicleImageName3}</p>
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Update
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal size="lg" show={vehicleModelShow} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Add Running Vehicle</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleVehicleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Vehicle Model Name" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.vehicleModelName}
                    className="input"
                    name="vehicleModelName"
                    type="text"
                    placeholder="Vehicle Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Registration Number" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.registrationNumber}
                    className="input"
                    name="registrationNumber"
                    type="text"
                    placeholder="Enter Registration Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Chasis Number" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.chasisNumber}
                    className="input"
                    name="chasisNumber"
                    type="text"
                    placeholder="Enter Chasis Number"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Engine Number" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.engineNumber}
                    className="input"
                    name="engineNumber"
                    type="text"
                    placeholder="Enter Engine Number"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Additional Charges" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.charges}
                    className="input"
                    name="charges"
                    type="text"
                    placeholder="Enter Charges"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="Description"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="On Road Date" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.onRoadDate}
                    className="input"
                    name="onRoadDate"
                    type="date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Location" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.location}
                    className="input"
                    name="location"
                    type="text"
                    placeholder="Location"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">User Manual</Form.Label>
                  <Form.Control onChange={onChangeManual} type="file" name="userManual" aria-required="false" />
                  <p>{purchaseOrderForm.userManualName}</p>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Warranty</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={5} className="warranty-btn mt-3">
                <span>Is Warranty Available?</span>
                <input
                  className="react-switch-checkbox"
                  id={`react-switch-new`}
                  type="checkbox"
                  onChange={handleToggle}
                  checked={purchaseOrderForm.warranty}
                  name="warranty"
                />
                <label className="react-switch-label" htmlFor={`react-switch-new`}>
                  <span className="no">NO</span>
                  <span className={`react-switch-button`} />
                  <span className="yes">YES</span>
                </label>
              </Col>
              {purchaseOrderForm.warranty === true ? (
                <Col xs={4} className="mt-4">
                  <FloatingLabel controlId="floatingInput" label="Warranty Covered Till" className="mt-1">
                    <Form.Control
                      onChange={handleChange}
                      value={purchaseOrderForm.warrantyDate}
                      className="input"
                      name="warrantyDate"
                      type="date"
                    />
                  </FloatingLabel>
                </Col>
              ) : (
                ''
              )}
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Drivers details</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Driver Name">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.driverName}
                    className="input"
                    name="driverName"
                    type="text"
                    placeholder="Driver Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Driver Mobile">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.driverMobile}
                    className="input"
                    name="driverMobile"
                    type="text"
                    placeholder="Driver Mobile"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Driver Address">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.driverAddress}
                    className="input"
                    name="driverAddress"
                    type="text"
                    placeholder="Driver Address"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Reference</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Reference Name" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.referenceName}
                    className="input"
                    name="referenceName"
                    type="text"
                    placeholder="Reference Name"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Reference Mobile" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.referenceMobile}
                    className="input"
                    name="referenceMobile"
                    type="text"
                    placeholder="Reference Mobile"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Documents</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 1</Form.Label>
                  <Form.Control onChange={onChangeWarrantyDocument} type="file" name="warrantyDocument" aria-required="false" />
                  <p>{purchaseOrderForm.warrantyDocumentName}</p>
                </Form.Group>
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 2</Form.Label>
                  <Form.Control onChange={onChangeBill} type="file" name="bill" aria-required="false" />
                  <p>{purchaseOrderForm.billName}</p>
                </Form.Group>
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 3</Form.Label>
                  <Form.Control onChange={onChangeVehicleImage1} type="file" name="vehicleImage1" aria-required="false" />
                  <p>{purchaseOrderForm.vehicleImageName1}</p>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 4</Form.Label>
                  <Form.Control onChange={onChangeVehicleImage2} type="file" name="vehicleImage2" aria-required="false" />
                  <p>{purchaseOrderForm.vehicleImageName2}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 5</Form.Label>
                  <Form.Control onChange={onChangeVehicleImage3} type="file" name="vehicleImage3" aria-required="false" />
                  <p>{purchaseOrderForm.vehicleImageName3}</p>
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Add
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default RunningVehicleList;
